import React from 'react';
import useStyles from './Styles';
import { Box, Typography, Grid } from '@material-ui/core';
import sidebarCollapse from '../../assets/sidebar-hide.png';

const ChartDrawer = (props) => {
    const classes = useStyles();
    const { onClose } = props;
    return (
        <Box className={classes.chartDrawer}>
            <Grid container item>
                <Grid item xs={12} className={classes.chartItem} 
                    style={{ 
                        height: 90, 
                        background: 'transparent', 
                        marginBottom: 0, 
                        flexDirection: 'row', 
                        alignItems: 'center' 
                    }}
                >
                    <Typography variant='h4' component='div' className={classes.chooseText}>Choose Chart</Typography>
                    <img
                        src={sidebarCollapse}
                        className={classes.chartToggleIcon}
                        style={{ paddingRight: 32 }}
                        onClick={onClose}
                        alt="toggle-icon.png"
                    />
                </Grid>
                <Grid item xs={12} className={classes.chartItem}>
                    <Typography variant='h6' component='div' className={classes.chartItemTitle}>Shortage Impacts to River Communities vs Central Arizona</Typography>
                    <Typography variant='body2' component='p' className={ classes.chartItemDesc }>Explanation about what this means and what the narrative measures on the base level.</Typography>
                </Grid>
                <Grid item xs={12} className={classes.chartItem}>
                    <Typography variant='h6' component='div' className={classes.chartItemTitle}>Shortage Impacts by Arizona Region</Typography>
                    <Typography variant='body2' component='p' className={ classes.chartItemDesc }>Explanation about what this means and what the narrative measures on the base level.</Typography>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ChartDrawer;